import BaseApi from '../../../api/BaseApi';

const basePath = '/channel/telegram';

class TelegramChannelApi {
  static create(body) {
    return BaseApi.post(basePath + '/create', body);
  }

  static list() {
    return BaseApi.get(basePath + '/list');
  }

  static view(id) {
    return BaseApi.get(basePath + '/view/' + id);
  }

  static info(id) {
    return BaseApi.get(basePath + '/info/' + id);
  }

  static update(id, body) {
    return BaseApi.put(basePath + '/update/' + id, body);
  }

  static delete(id) {
    return BaseApi.delete(basePath + '/delete/' + id);
  }
}

export default TelegramChannelApi;
